import React, { useEffect, useState } from "react";
import DeliveryConfirmationBreakdownTable from "../../components/deliveryConfirmationBreadownTable";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { useFetch } from "../../utils/fetchHook";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useTranslation } from "react-i18next";

const dspDict = {
  '1': ['YouTube Content ID'],
  '2': ['YouTube Premium'],
  '3': ['YouTube Content ID, YouTube Premium'],
  '5': ['Beatport'],
  '6': ['Airtel', 'HighResAudio', 'LINE Music', 'Etisalat', 'Tidal', 'Binge', 'Joox', 'Audible Licensing', 'Moodagent', 'MicDrop', '7Digital', 'Exlibris', 'Soundhound', 'iHeartRadio', 'Genie Music', 'MX Player ', 'iMusica', 'Kuack Media', 'Vodafone Play', 'Slacker', 'MePlaylist', 'Yandex Music', 'Audiomack', 'Beatsource', 'Vodafone', 'Nuuday A/S', 'Bugs!', 'TIM Music', 'Digicel', 'Electric Jukebox / Roxi', 'Xiami', "Music in 'Ayoba'", 'Mi TV', 'MyMelo', 'Napster', 'KkBox', 'NEC', 'Pretzel Rocks', 'Jaxsta Music', 'Shareit', 'PlayNetwork', 'Tencent', 'Supernatural', 'AWA', 'Boomplay Music', 'Stellar Entertainment', 'Grandpad', 'TouchTunes', 'QQ Music', 'Gracenote', 'Anghami', 'LICKD', 'Boomerang', 'A1 Xplore Music', 'Fan Label', 'Ncell', 'Soundtrack Your Brand', 'Peloton', 'Simfy Africa', 'Idea', 'NetEase', 'Wynk', 'Lasso', 'United Media Agency', 'Hungama', 'SparkAR', 'Airtel TV', 'Virgin Australia', 'Mixcloud', 'Dub Store Sound Inc.', 'Soundmouse', 'JioSaavn', 'MTNL', 'Nepal Telecom', 'Kakao / MelOn', 'BMAT', 'GrooveFox', 'Qobuz', 'MTN', 'Telenor', 'SoundMachine', 'SunExpress', 'Hardstyle.com', 'Bitel', 'Xite', 'FLO', 'Fizy', 'Shazam', 'NAVER VIBE', 'Global Radio'],
  '7': ['Traxsource'],
  '8D': ['Deezer'],
  '8J': ['Junodownload'],
  '8S': ['Spotify'],
  '83086': ['7digital (Massive Music)', 'Canva', 'Coda Music', 'Snap', 'Pinterest', 'Pretzel Aux', 'ROXI', 'Songtradr', 'Soundtrack Your Brand', 'Trebel', 'PEX'],
  '83087': ['AMI Entertainment'],
  '83088': ['Anghami'],
  '83089': ['Audiomack'],
  '83090': ['AWA'],
  '83091': ['BMAT'],
  '83092': ['Boomplay'],
  '83093': ['FLO'],
  '83094': ["Click'N'Clear"],
  '83095': ['Gracenote'],
  '83096': ['IHeartRadio'],
  '83097': ['IMusica'],
  '83098': ['JOOX'],
  '83099': ['KKBox'],
  '83100': ['Kuack'],
  '83101': ['Kuaishou'],
  '83102': ['Melon'],
  '83103': ['MixCloud'],
  '83104': ['NetEase'],
  '83105': ['PretzelAux'],
  '83106': ['Qobuz'],
  '83107': ['Saavn'],
  '83108': ['SoundMouse'],
  '83109': ['Taobao'],
  '83110': ['QQ Music (Tencent)'],
  '83111': ['Tidal'],
  '83112': ['Touchtunes'],
  '83113': ['Trebel Music'],
  '83114': ['TunedGlobal'],
  '10': ['Douyin', 'TikTok'],
  '11': ['Twitch', 'Audible Magic'],
  '14': ['Facebook AL', 'Faacebook FP', 'Instagram'],
  '15': ['Amazon Music', 'Amazon Unlimited', 'Amazon Prime'],
  '16': ['SoundCloud GO+', 'SoundCloud'],
  '17': ['Deezer'],
  '19': ['Pandora'],
  '20': ['Apple Music', 'iTunes']
}

const DeliveryConfirmationBreakdown = props => {
  const token = getCookie("token");
  const location = useLocation();
  const { t } = useTranslation();
  const confirmationID = location.pathname.split("/")[2];
  const [apiData, error, loading] = useFetch("GET",`ddex-delivery-confirmations/${confirmationID}/`, token);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if(apiData.store_confirmations)
    {
      const storeDeliveryList = [];
      for (const confirmation of apiData.store_confirmations) {
        const store = confirmation.store;
        const status = confirmation.status;
        if (dspDict.hasOwnProperty(store)) {
          const dspNames = dspDict[store]
          for (const dspName of dspNames) {
            let additionalNote = ""
            let russianDsp = false;
            if(dspName === "Apple Music" || dspName === "iTunes") {
              if(status){
                additionalNote = t("deliveryConfirmation.breakdownView.message.appleSubjectToQC")
              }
              else {
                additionalNote = t("deliveryConfirmation.breakdownView.message.appleSubjectToQC")
              }
            }
            else if(dspName === "United Media Agency" || dspName === "Yandex Music") {
              additionalNote = t("deliveryConfirmation.breakdownView.message.noDeliveriesPossible")
              russianDsp = true;
            }
            else {
              if(status) {
                additionalNote = t("deliveryConfirmation.breakdownView.message.releaseDeliverySuccessfull", {dspName: dspName})
              }
              else {
                additionalNote = t("deliveryConfirmation.breakdownView.message.releaseDeliveryUnsuccessfull", {dspName: dspName})
              }
            }
            const deliveryObj = {
              store: dspName,
              status: russianDsp? false: status,
              additionalNote: additionalNote,
            };
            storeDeliveryList.push(deliveryObj);
          }

        }
      }
      storeDeliveryList.sort((a, b) => a.store.localeCompare(b.store));
      setTableData(storeDeliveryList);
    }
  }, [apiData]);

  const tableProps = {
    tableData,
    error,
    loading,
  };

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          <ViewLayout title={t("deliveryConfirmation.breakdownView.table.title")}>
            <DeliveryConfirmationBreakdownTable
              {...tableProps}
            />
          </ViewLayout>
        </div>
      )}
    </>
  );
};

export default DeliveryConfirmationBreakdown;